import React from "react";
import {IModule} from "../Utils/Interface";
import Popover from "./Popover";
import { observer } from "mobx-react";
import Tooltip from "react-simple-tooltip";
import {generalConfigurationStore} from "../Stores/GeneralConfigurationStore";
import {IValidationResult} from "../Stores/ProductConfigurationStore";

type Props = {
	addOn: IModule;
	onChange: (addOn: IModule) => void;
	isSelected: (addOn: IModule) => boolean;
	canSelectModule: (module: IModule) => IValidationResult;
	displayType: string;
};

type State = {
	isPopoverOpen: boolean;
};

@observer
class ModuleAddOns extends React.Component<Props, State> {
	constructor(props: Props) {
		super(props);
		// set initial state in constructor directly
		this.state = {
			isPopoverOpen: false,
		};
	}

	handlePopover = (e: any) => {
		e.preventDefault();

		this.setState({ isPopoverOpen: !this.state.isPopoverOpen });

		if (!this.state.isPopoverOpen) {
			document.body.style.overflowY = "hidden";
		} else {
			document.body.style.overflowY = "unset";
		}
	};

	render() {
		const addon = this.props.addOn;
		const isSelected = this.props.isSelected(addon);
		const canSelectModule = this.props.canSelectModule(addon);
		const incompatibleMessage =
			canSelectModule.valid === false
				? `${generalConfigurationStore.configs?.generalIncompatibleText} ${canSelectModule.reason.modules.map((m) => m.title).join(", ")}`
				: undefined;

		return (
			<>
				{this.props.displayType === "tile" ? (
					<>
						<div className={`module-tile ${this.props.isSelected(addon) ? "selected" : ""} ${!canSelectModule.valid ? " incompatible" : ""}`}>
							{!canSelectModule.valid &&
								<Tooltip
									className="tooltip-container"
									content={incompatibleMessage}
									offset={0}
									style={{ position: "absolute", display: "block" }}
								>
									<button
										className="tooltip-button"
									></button>
								</Tooltip>
							}
							<div className="module-popover" onClick={this.handlePopover}></div>

							{this.state.isPopoverOpen && (
								<Popover
									headline={addon.title}
									description={addon.content}
									incompatibleMessage={incompatibleMessage}
									thumbnail={addon.thumbnail}
									galleryImages={addon.gallery}
									onClose={() => {
										this.setState({ isPopoverOpen: !this.state.isPopoverOpen });
										if (!this.state.isPopoverOpen) {
											document.body.style.overflowY = "hidden";
										} else {
											document.body.style.overflowY = "unset";
										}
									}}
								/>
							)}
							<div className="module-image-wrapper" onClick={(e) => this.props.onChange(addon)}>
								<img className="module-image" src={addon.thumbnail} alt={addon.title} />
								<div className="module-selected"></div>
							</div>
							<div className="module-wrapper">
								<div className="module-name">
									<span>{addon.title}</span>
									<span>{addon.subheadline}</span>
								</div>
								<p>{addon.moduleFields?.mrModuleSku}</p>
							</div>
						</div>
					</>
				) : (
					<label className={`multi-select-label addon`}>
						{this.state.isPopoverOpen && (
							<Popover
								headline={addon.title}
								description={addon.content}
								onClose={() => {
									this.setState({ isPopoverOpen: !this.state.isPopoverOpen });
									if (!this.state.isPopoverOpen) {
										document.body.style.overflowY = "hidden";
									} else {
										document.body.style.overflowY = "unset";
									}
								}}
							/>
						)}
						<input
							type="checkbox"
							onChange={(e) => this.props.onChange(addon)}
							className="multi-select-check-input"
							value={addon.title}
							checked={isSelected}
						/>
						<span>{addon.title}</span>
					</label>
				)}
			</>
		);
	}
}

export default ModuleAddOns;
